import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import TodoTab from '../../components/practitioner/TodoTab';
import ComplianceTab from '../../components/practitioner/ComplianceTab';
import WellnessLogsTab from '../../components/practitioner/WellnessLogsTab';
import PhotosTab from '../../components/practitioner/PhotosTab';
import MessagesTab from '../../components/practitioner/MessagesTab';
import SymptomToggles from '../../components/practitioner/SymptomToggles';
import WeeklyCheckInsTab from '../../components/practitioner/WeeklyCheckInsTab';
import SupplementsTab from '../../components/practitioner/SupplementsTab';
import ToolkitTab from '../../components/practitioner/ToolkitTab';
import './ClientView.css';

const TABS = [
  { key: 'todo', label: 'To-Do' },
  { key: 'supplements', label: 'Supplements' },
  { key: 'compliance', label: 'Compliance' },
  { key: 'wellness', label: 'Symptom Tracker' },
  { key: 'history', label: 'Daily History' },
  { key: 'checkins', label: 'Check-Ins' },
  { key: 'toolkit', label: 'Toolkit' },
  { key: 'photos', label: 'Photos' },
  // { key: 'messages', label: 'Messages' },  // hidden for now
];

export default function ClientView() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('todo');
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClient();
  }, [clientId]);

  async function loadClient() {
    setLoading(true);
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .eq('id', clientId)
      .single();

    if (error || !data) {
      navigate('/practitioner', { replace: true });
      return;
    }
    setClient(data);
    setLoading(false);
  }

  if (loading || !client) {
    return (
      <div className="screen container">
        <div style={{ textAlign: 'center', padding: '80px 0', color: 'var(--color-text-muted)' }}>
          Loading client...
        </div>
      </div>
    );
  }

  const initials = client.name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="screen container cv-screen">
      <button onClick={() => navigate('/practitioner')} className="back-link">
        ← Dashboard
      </button>

      <div className="cv-header">
        <div className="cv-avatar">{initials}</div>
        <div>
          <h1 className="cv-name">{client.name}</h1>
          <p className="cv-email">{client.email}</p>
        </div>
      </div>

      <nav className="cv-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`cv-tab ${activeTab === tab.key ? 'cv-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className="cv-tab-content">
        {activeTab === 'todo' && <TodoTab clientId={clientId} client={client} />}
        {activeTab === 'supplements' && <SupplementsTab clientId={clientId} client={client} />}
        {activeTab === 'compliance' && <ComplianceTab clientId={clientId} client={client} />}
        {activeTab === 'wellness' && (
          <SymptomToggles clientId={clientId} client={client} onUpdate={setClient} />
        )}
        {activeTab === 'history' && <WellnessLogsTab clientId={clientId} client={client} />}
        {activeTab === 'checkins' && <WeeklyCheckInsTab clientId={clientId} />}
        {activeTab === 'toolkit' && <ToolkitTab clientId={clientId} client={client} />}
        {activeTab === 'photos' && <PhotosTab clientId={clientId} />}
        {/* {activeTab === 'messages' && <MessagesTab clientId={clientId} client={client} />} */}
      </div>
    </div>
  );
}
